var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstKid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6EE1FF"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41A0D7"
    },
    d: "M326.409,129.487H256h-70.409v58.713h-79.796v193.389l129.582,129.582 C242.18,511.713,249.056,512,256,512c129.327,0,236.236-95.905,253.534-220.471L406.205,188.199h-21.084L326.409,129.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5415F"
    },
    d: "M326.409,240.263H185.591V129.487h140.818V240.263z M213.755,212.1h84.491v-54.449h-84.491V212.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C32850"
    },
    points: "256,157.651 298.245,157.651 298.245,212.1 256,212.1 256,240.263 326.409,240.263  326.409,129.487 256,129.487 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.797,
    y: 188.199,
    style: {
      fill: "#FFFFFF"
    },
    width: 300.416,
    height: 193.388
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 188.199,
    style: {
      fill: "#A0EBFF"
    },
    width: 150.203,
    height: 193.388
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF6473"
    },
    cx: 256,
    cy: 284.898,
    r: 79.793
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5415F"
    },
    d: "M335.796,284.895c0-44.07-35.726-79.796-79.796-79.796v159.593 C300.07,364.691,335.796,328.965,335.796,284.895z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "308.69,265.13 275.764,265.13 275.764,232.206 236.236,232.206 236.236,265.13  203.31,265.13 203.31,304.659 236.236,304.659 236.236,337.584 275.764,337.584 275.764,304.659 308.69,304.659 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBF0"
    },
    points: "275.764,232.206 256,232.206 256,337.584 275.764,337.584 275.764,304.659 308.69,304.659  308.69,265.13 275.764,265.13 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstKid);
export default __webpack_public_path__ + "static/media/firstKid.475026ae40a591f583b8451e26dd2d1e.svg";
export { ForwardRef as ReactComponent };